angular.module('harriApp').factory('hSocket', ['hUser', 'dependenciesLoaderService', function (hUser, dependenciesLoaderService) {

    const self = this;
    let events = {};
    let pusher;
    let channel;

    const onSubscriptionErrorEvent = (error) => {
        throw error;
    };

    const onPusherErrorEvent = (error) => {
        throw error;
    };

    const DEFAULT_PUSHER_EVENTS = {
        'pusher:subscription_error': [onSubscriptionErrorEvent],
        'pusher:error': [onPusherErrorEvent],
    };

    const loadPusherScript = () => {
        return new Promise((resolve, reject) => {
            if (typeof Pusher === 'undefined') {
                dependenciesLoaderService.load([{path: "pusher-js", type: "library", name: "pusher-js"}])
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        console.error('Error loading Pusher lib', err)
                        reject(err);
                    })
            }
            else {
                resolve('ALREADY_LOADED');
            }
        });
    }

    self.init = (pusherConfig, authTokenApi, namePrefix) => {
        return new Promise ((resolve, reject) => {
            loadPusherScript()
                .then((res) => {
                    const id = hUser.data.user.team_user_id;
                    const name = namePrefix + id;
                    pusher = new Pusher(pusherConfig['KEY'], {
                        cluster: pusherConfig['CLUSTER'],
                        authorizer: (channel, options) => {
                            return {
                                authorize: (socketId, callback) => {
                                    authTokenApi(name, socketId).then((token) => {
                                        callback(null, token);
                                        resolve();
                                    })
                                }
                            }
                        }
                    });

                    channel = pusher['subscribe'](name);

                    events = $.extend({}, DEFAULT_PUSHER_EVENTS);
                    pusher.bind_global((eventName, data) => {
                        if (events[eventName]?.length) {
                            for (const i in events[eventName]) {
                                events[eventName][i](data);
                            }
                        }
                    });
                });
        });
    };

    self.registerEvent = (eventName, eventHandler) => {
        events[eventName] = events[eventName] || [];
        events[eventName].push(eventHandler);
    }

    self.unregisterEvent = (eventName, eventHandler) => {
        if (events[eventName]?.length) {
            const handlerIndex = events[eventName].findIndex((handler) => {
                return handler == eventHandler;
            })
            if (handlerIndex > -1) {
                events[eventName].splice(handlerIndex, 1);
            }
        }
    }

    self.triggerEvent = (eventName, data) => {
        channel['trigger'](eventName, data)
    }

    self.close = () => {
        pusher.disconnect();
    }

    return self;
}]);
